import PropTypes from "prop-types";

function HealthScoreGauge({ score, color }) {
  const normalizedScore = Math.max(0, Math.min(100, score));
  const angle = Math.round((normalizedScore / 100) * 360);

  return (
    <div
      className="sd-health-gauge"
      style={{
        background: `conic-gradient(${color} ${angle}deg, #e7edf4 ${angle}deg)`,
      }}
    >
      <div className="sd-health-gauge__inner">
        <span>{normalizedScore}</span>
        <span>/ 100</span>
      </div>
    </div>
  );
}

HealthScoreGauge.propTypes = {
  score: PropTypes.number.isRequired,
};

export default HealthScoreGauge;
